import $ from 'jquery';
import { importModule } from 'disy';

export function alert (title, message, options = {}) {
  return _alert(title, message, {type: options.type});
}

export function errorAlert (title, message) {
  return alert(title, message, {type: 'error'});
}

export function confirm (title, message, options = {}) {
  const {submit, alternativeSubmit, cancel = true} = options;
  return _alert(title, message, {submit, alternativeSubmit, cancel});
}

function _alert (title, message, options) {
  return importModule('alert-dialog').then((AlertDialog) => {
    const result = new $.Deferred();
    const dialog = new AlertDialog(title, message, options);
    $(dialog)
      .on('cancel', (event) => {
        if (options.cancel) {
          result.reject();
        } else {
          event.preventDefault();
        }
      })
      .on('close', () => result.resolve(dialog.returnValue))
      .appendTo(document.body);
    result.always(() => dialog.remove());
    dialog.showModal();
    return result.promise();
  });
}
